module.exports = __webpack_public_path__ + "static/media/18ECA18.9582debc.jpg";